import type { NavigateOptions } from "@tanstack/react-router";

export const newProjectNavigation = (
  projectId: string,
  from: string,
): NavigateOptions => ({
  to: "/projects/$projectId",
  params: { projectId },
  search: { newProject: "true" },
  state: { from },
});
